import './CreatorUpload.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import * as mintUtils from './mintUtils';
import FileUpload from './FileUpload';
import CreatorUploadTitleForm  from './CreatorUploadTitleForm';
import CreatorUploadCreatorNameForm  from './CreatorUploadCreatorNameForm';
import CreatorUploadDescriptionForm from './CreatorUploadDescriptionForm';
import CreatorUploadMonetizationForm  from './CreatorUploadMonetizationForm';
import HyperaceConnectWalletModal from './HyperaceConnectWalletModal';
import FileUploadImage from './FileUploadImage';
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { contractAddress, mainnetContractAddress } from "./config";

let web3;
let usedContractAddress;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = contractAddress;
}
const contract = require('./artifacts/contracts/The402NFT.sol/The402NFT.json');

const axios = require('axios');

function CreatorUpload(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [publishInit, setPublishInit] = useState(false);
  const [usdPriceMATIC, setUsdPriceMATIC] = useState("Invalid coinbase exchange rate request");
  const [usdPriceETH, setUsdPriceETH] = useState("Invalid coinbase exchange rate request");

  let params = {};

  if(typeof location.state != "undefined"){
    params = location.state.params;
  }

  useEffect(() => {
    const getUSDETH = async () => {
      let USDPriceETH = "Invalid coinbase exchange rate request"
      let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
      if(data != null) {
        USDPriceETH = data["data"]["data"]["rates"]["USD"]
      }
      return USDPriceETH;
    }
    getUSDETH().then(price => setUsdPriceETH(price));
  }, []);

  useEffect(() => {
    const getUSDMATIC = async () => {
      let USDPriceMATIC = "Invalid coinbase exchange rate request"
      let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "MATIC" } });
      if(data != null) {
        USDPriceMATIC = data["data"]["data"]["rates"]["USD"]
      }
      return USDPriceMATIC;
    }
    getUSDMATIC().then(price => setUsdPriceMATIC(price));
  }, []);

  async function mintNFT() {
    if(publishInit) {
      return;
    }
    setPublishInit(true);
    loggingUtils.logEvent(
      props.account != null ? props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'creator_upload',
      'creator_upload_item',
      'info',
      "https://the402.xyz",
      {},
    );
    const editions = params.editions;
    const title = params.name;
    const creatorRoyaltyPercentage = params.creatorRoyaltyPercentage;
    const impressionFee = params.impressionFee;
    const impressionPercentage = params.impressionPercentage;
    const file = params.file[0];
    let newHolderShares = (100 - impressionPercentage)*2;
    let creatorShares = impressionPercentage*editions*2;

    params["holderShares"] = newHolderShares;
    params["creatorShares"] = creatorShares;

    const authSig = await encryptUtils.getAuthSig();
    params["creatorAddress"] = props.account.address;

    // upload cover photo to pinata
    let coverPhotoURL = await encryptUtils.writeFilePinata(title, params.image);
    if(params.previewFile != null) {
      let previewURL = await encryptUtils.writeFilePinata(title, params.previewFile);
      params["animation_url"] = previewURL.replace('gateway.pinata', 'the402.mypinata');
    }
    params["imagePinata"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
    params["image"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');

    // encrypt the file
    let authUUID = encryptUtils.getAuthUUID();
    let encryptedSongInfo = await encryptUtils.encryptSong(params.file, authUUID, authSig);
    let { encryptedSymmetricKey } = encryptedSongInfo;

    //upload file to s3 not encrypted and update the params for the file
    const fileType = file.type;
    let mediaType;
    if(fileType.match("audio")){
      mediaType = 1;
    }else if (fileType.match("video")){
      mediaType = 0;
    }

    params["mediaType"] = mediaType;

    // upload encrypted content to pinata
    let encryptedURL = await encryptUtils.writeSongPinata(encryptedSongInfo,title);

    // upload the metadata with link to the encrypted info to pinata
    let ppvHash = await encryptUtils.writeMetadataPinata(encryptedURL, encryptedSymmetricKey, params);
    console.log(ppvHash);

    const ppvContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    ppvContract.events.UpcomingMintPublished().on("data", async function(event) {
      let data = event.returnValues;
      console.log(data);
      console.log(authUUID);
      if(data["authUUID"] !== authUUID) {
        return;
      }
      let nextCollectibleID = parseInt(data["nextTokenId"]);
      await mintUtils.openMint(props.account.address, nextCollectibleID, "the402");
      navigate("/media/" + authUUID + "?protocol=the402" + "&autorefresh=true");
    });

    await mintUtils.publishUpcomingMintWithInfo(
      ppvHash,
      creatorShares,
      newHolderShares,
      impressionFee,
      creatorRoyaltyPercentage,
      props.account.address,
      params.editions,
      params.mintPrice,
      mediaType,
      authUUID
    );
  }

  function setFile(file) {
    params["file"] = file;
  }

  function setPreviewFile(file) {
    params["previewFile"] = file;
  }

  function setCoverPhoto(coverPhoto) {
    params["image"] = coverPhoto;
  }

  function setCreatorName(creatorName) {
    params["creatorName"] = creatorName;
  }

  function setTitle(title) {
    params["name"] = title;
  }

  function setDescription(description) {
    params["description"] = description;
  }

  function setRoyalty(royalty) {
    params["creatorRoyaltyPercentage"] = royalty;
  }

  function setImpressionFee(impressionFee) {
    params["impressionFee"] = impressionFee;
  }

  function setImpressionPercentage(impressionPercentage) {
    params["impressionPercentage"] = impressionPercentage;
  }

  function setEditions(editions) {
    params["editions"] = editions;
  }

  async function setMintPrice(price) {
    params["mintPrice"] = price;
    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
    if(data != null) {
      let USDPrice = data["data"]["data"]["rates"]["USD"]
      params["USD"] = (price * USDPrice).toFixed(2);
    }
  }

  function checkString(str) {
    return (str.match(/^[0-9]+$/) != null);
  }

  function checkStringWithDecimal(str) {
    return !isNaN(str) && parseFloat(str) >= 0;
  }

  function checkStringWithHalfIncrements(str) {
    return !isNaN(str) && parseFloat(str) % 0.5 === 0 && parseFloat(str) >= 0;
  }

  return (
    <div>
      {
        props.account != null
          ?
        <div className = "max-w-lg mx-auto pt-24">
          <div>
            <div>
              <FileUpload setMedia={setFile} isHyperace={false} />
              <div className="mt-8">
                <FileUpload setMedia={setPreviewFile} isHyperace={false} isPreview={true} />
              </div>
              <div className="mt-8">
                <FileUploadImage setMedia={setCoverPhoto}/>
              </div>
            </div>
            <CreatorUploadTitleForm setTitle={setTitle} params={params}/>
            <CreatorUploadCreatorNameForm setCreatorName={setCreatorName} params={params}/>
            <CreatorUploadDescriptionForm
              setDescription={setDescription}
              params={params}
            />
            <div className="creator-upload-titleFormContainer">
              <CreatorUploadMonetizationForm
                checkString={checkString}
                checkStringWithDecimal={checkStringWithDecimal}
                checkStringWithHalfIncrements={checkStringWithHalfIncrements}
                setMintPrice={setMintPrice}
                setEditions={setEditions}
                setRoyalty={setRoyalty}
                setImpressionFee={setImpressionFee}
                setImpressionPercentage={setImpressionPercentage}
                usdPriceETH={usdPriceETH}
                usdPriceMATIC={usdPriceMATIC}
                params={params}
              />
            </div>
          </div>
          <div className="h-24">
            {
              publishInit
                ?
              <div className="mx-auto mt-8 bg-black dark:bg-white h-16 w-64 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer" onClick={mintNFT}>
                <svg role="status" class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                Please wait
              </div>
                :
              <div className="mx-auto mt-8 bg-black dark:bg-white h-16 w-64 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer" onClick={mintNFT}>
                Confirm and upload
              </div>
            }
          </div>
        </div>
          :
        <div className="w-full">
          <HyperaceConnectWalletModal/>
        </div>
      }
    </div>
  );
}

export default CreatorUpload;
